<template>
  <div id="app">
    <StickTop />
    <router-view />
    <StickFooter />
  </div>
</template>

<script>
import StickFooter from "@/components/StickFooter.vue";
import StickTop from "@/components/StickTop.vue";
import { mapActions, mapGetters } from "vuex";
import nativeToast from "native-toast";

// <div id="mobile" class="pointer" v-if="mobilesite" v-on:click="refreshApp">
//   Mobile version available!
//   <img
//     data-v-a63b5448=""
//     alt="365.stream"
//     src="/icons/apple-touch-icon-152x152.png"
//     class="app-icon"
//   />
// </div>

export default {
  name: "App",
  data() {
    return {
      feeds: JSON.parse(localStorage.getItem("System_Feed")) || [],
      refreshing: false,
      registration: null,
    };
  },
  components: {
    StickTop,
    StickFooter,
  },
  socket: {
    events: {
      connect() {
        this.setConnect(true);
      },
      disconnect() {
        this.setConnect(false);
      },
    },
  },
  computed: mapGetters(["isAuthenticated", "getUser", "getPair"]),
  methods: {
    ...mapActions([
      "fetchFee",
      "fetchCoins",
      "fetchBalance",
      "fetchPairing",
      "setConnect",
      "setBalance",
      "setMarket",
      "setInvest",
      "UsersConnected",
      "UsersDisconnected",
    ]),
    detectmobile() {
      if (
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)
      ) {
        // localStorage.setItem("DetectMobile", "trade");
      } else {
        // localStorage.setItem("DetectMobile", "advanced");
      }
    },
    onlineUsers() {
      this.$socket.on(
        "users.joined",
        function (data) {
          this.UsersConnected(data);
        }.bind(this)
      );

      this.$socket.on(
        "users.left",
        function (data) {
          this.UsersDisconnected(data);
        }.bind(this)
      );

      this.$socket.on(
        "announce",
        function (data) {
          nativeToast({
            message: data.message,
            position: data.position,
            timeout: data.timeout,
            type: data.type,
          });
        }.bind(this)
      );
    },
    exchange() {
      this.fetchPairing();

      this.$socket.on(
        "market",
        function (data) {
          this.setMarket(data);
        }.bind(this)
      );
    },
    investbox() {
      this.$socket.on(
        "investbox",
        function (data) {
          this.setInvest(data);
        }.bind(this)
      );
    },
    systemfeeds() {
      this.feeds = this.feeds.slice(-100);
      this.$socket.off("system_feed");
      this.$socket.on(
        "system_feed",
        function (data) {
          this.feeds.push(data);
          localStorage.setItem("System_Feed", JSON.stringify(this.feeds));
        }.bind(this)
      );
    },
    showRefreshUI(e) {
      // Display a button inviting the user to refresh/reload the app due
      // to an app update being available.
      // The new service worker is installed, but not yet active.
      // Store the ServiceWorkerRegistration instance for later use.
      this.registration = e.detail;
      this.refreshApp();
    },
    refreshApp() {
      // Protect against missing registration.waiting.
      if (!this.registration || !this.registration.waiting) {
        return;
      }
      this.registration.waiting.postMessage("skipWaiting");
    },
  },
  created() {
    this.fetchFee();
    this.fetchCoins();
    this.onlineUsers();
    this.exchange();
    this.investbox();
    this.detectmobile();
    this.systemfeeds();

    if (this.isAuthenticated) {
      this.fetchBalance();

      this.$socket.on(
        "user.balance." + this.getUser._id,
        function (data) {
          this.setBalance(data);
        }.bind(this)
      );
    }

    // Listen for swUpdated event and display refresh snackbar as required.
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    // Refresh all open app tabs when a new service worker is installed.
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (this.refreshing) return;
      this.refreshing = true;
      window.location.reload();
    });
  },
};
</script>

<style scoped>
@-webkit-keyframes fadein {
  from {
    bottom: 0;
  }
  to {
    bottom: 100px;
  }
}
@keyframes fadein {
  from {
    bottom: 0;
  }
  to {
    bottom: 100px;
  }
}
#mobile {
  min-width: 250px;
  margin-left: -125px;
  background-color: #32353c;
  color: #fff;
  text-align: center;
  border-radius: 2px;
  padding: 3px;
  position: fixed;
  z-index: 1;
  left: 50%;
  bottom: 100px;
  -webkit-animation: fadein 0.5s;
  animation: fadein 0.5s;
}
.app-icon {
  margin: 10px auto;
  width: 32px;
  height: 32px;
  border-radius: 5px;
  padding: 0px;
}
</style>
